
import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionUtility from '@/controllers/options/DeliveryOptionUtility';
import { Options, Prop, Vue } from 'vue-property-decorator';
import PreviewMode from './preview/PreviewMode.vue';
import CountdownTimer from './timer/CountdownTimer.vue';
import PauseButton from './timer/PauseButton.vue';
import ExitButton from './timer/ExitButton.vue';

@Options({
  components: { CountdownTimer, PauseButton, PreviewMode, ExitButton },
})
export default class PlayerHeader extends Vue {
  @Prop() readonly titleDeliveryOption: DeliveryOption | undefined;
  @Prop({ default: '100%' }) readonly width: string | undefined;
  @Prop({ default: '1400px' }) readonly maxWidth: string | undefined;
  @Prop({}) readonly timerDeliveryOption: DeliveryOption | undefined;
  @Prop() readonly pauseButtonOption: DeliveryOption | undefined;
  @Prop() readonly exitButtonOption: DeliveryOption | undefined;
  @Prop({ default: '' }) previewModeText: string | undefined;
  @Prop({ default: false }) previewMode: boolean | undefined;
  @Prop({}) readonly displayNameDeliveryOption: DeliveryOption | undefined;
  @Prop({ default: false }) readonly pauseTest: boolean | undefined;

  private displayPauseButton(): boolean {
    return DeliveryOptionUtility.deliveryOptionHasExpectedValue(
      this.pauseButtonOption,
      DeliveryOptionConstants.PAUSE_BUTTON,
      'value',
      'true'
    );
  }
  private displayExitButton(): boolean {
    return DeliveryOptionUtility.deliveryOptionHasExpectedValue(
      this.exitButtonOption,
      DeliveryOptionConstants.EXIT_BUTTON,
      'value',
      'true'
    );
  }
  private showDisplayName(): boolean {
    return (
      this.displayNameDeliveryOption !== undefined &&
      DeliveryOptionUtility.deliveryOptionHasExpectedValue(
        this.displayNameDeliveryOption,
        DeliveryOptionConstants.STUDENT_NAME,
        'value',
        'true'
      )
    );
  }

  private get displayName(): string {
    if (this.displayNameDeliveryOption) {
      const value: string | undefined = this.displayNameDeliveryOption.getSetting('displayName');
      return value ? value : '';
    }
    return '';
  }

  private getMinimumHeight(): string {
    return this.previewMode ? '70px' : '0';
  }

  private get isPreviewMode(): boolean {
    return this.previewMode ? this.previewMode : false;
  }

  private get hideTitleContainer(): boolean {
    return (
      !this.keyAndValuePresent(this.titleDeliveryOption, 'title') &&
      !this.keyAndValuePresent(this.titleDeliveryOption, 'subtitle')
    );
  }

  private get title(): string | undefined {
    return this.titleDeliveryOption ? this.titleDeliveryOption.getSetting('title', '') : '';
  }

  private get subtitle(): string | undefined {
    return this.titleDeliveryOption ? this.titleDeliveryOption.getSetting('subtitle', '') : '';
  }

  private keyAndValuePresent(deliveryOption: DeliveryOption | undefined, key: string): boolean {
    if (deliveryOption) {
      if (deliveryOption.getSetting(key)) {
        if (deliveryOption.getSetting(key)!.trim().length > 0) {
          return true;
        }
      }
    }
    return false;
  }
}
